export { default as Main } from "./Main.vue";

import { useI18n } from "vue-i18n";

export const FilterType = Object.freeze({
    LINKED_TO: "linked_to",
    ASSIGNED_TO: "assigned_to",
    PRIORITY: "priority",
    SPACES: "spaces",
    ASSETS: "assets",
    ASSET_GROUPS: "asset_groups",
    TAGS: "tags",
    CATEGORY: "category",
    BRAND: "brand",
    SUPPLIER: "supplier",
    VISIBILITY: "visibility",
    TASK_TYPE: "task_type",
    DUE_DATE: "due_date",
    LOGGED_DATE: "logged_date",
    CREATED_DATE: "created_date",
    COMPLETED_DATE: "completed_date",
    EXPIRATION_DATE: "expiration_date",
    NOTIFICATION_DATE: "notification_date",
    PURCHASED_DATE: "purchased_date",
    STATUS: "status",
    RECURRENCE: "recurrence",
});

export function useMain(tenantIds = [], type) {
    const { t } = useI18n();

    let optionGroups = [];

    if (!type) {
        return [];
    }

    if (type === "tasks") {
        optionGroups = [
            {
                options: [
                    {
                        id: FilterType.STATUS,
                        icon: "branch",
                        label: t("components.filters.status.label"),
                    },
                    {
                        id: FilterType.ASSIGNED_TO,
                        icon: "user-single",
                        label: t("components.filters.assigned_to.label"),
                    },
                    {
                        id: FilterType.PRIORITY,
                        icon: "error-circle",
                        label: t("components.filters.priority.label"),
                    },
                    {
                        id: FilterType.CATEGORY,
                        icon: "hashtag-square",
                        label: t("components.filters.category.label"),
                    },
                    {
                        id: FilterType.TAGS,
                        icon: "tag",
                        label: t("components.filters.tags.label"),
                    },
                    {
                        id: FilterType.VISIBILITY,
                        icon: "lock-closed",
                        label: t("components.filters.visibility.label"),
                    },
                    {
                        id: FilterType.TASK_TYPE,
                        icon: "clipboard",
                        label: t("components.filters.task_type.label"),
                    },
                ],
            },
            {
                options: [
                    {
                        id: FilterType.CREATED_DATE,
                        icon: "calendar-plus",
                        label: t("components.filters.created_date.label"),
                    },
                    {
                        id: FilterType.DUE_DATE,
                        icon: "calendar-time",
                        label: t("components.filters.due_date.label"),
                    },
                    {
                        id: FilterType.COMPLETED_DATE,
                        icon: "calendar-check",
                        label: t("components.filters.completed_date.label"),
                    },
                ],
            },
        ];
    }

    if (type === "files") {
        optionGroups = [
            {
                options: [
                    {
                        id: FilterType.VISIBILITY,
                        icon: "lock-closed",
                        label: t("components.filters.visibility.label"),
                    },
                    {
                        id: FilterType.TAGS,
                        icon: "tag",
                        label: t("components.filters.tags.label"),
                    },
                ],
            },
            {
                options: [
                    {
                        id: FilterType.CREATED_DATE,
                        icon: "calendar-plus",
                        label: t("components.filters.created_date.label"),
                    },
                    {
                        id: FilterType.EXPIRATION_DATE,
                        icon: "calendar-dash",
                        label: t("components.filters.expiration_date.label"),
                    },
                    {
                        id: FilterType.NOTIFICATION_DATE,
                        icon: "bell-default",
                        label: t("components.filters.notification_date.label"),
                    },
                ],
            },
        ];
    }

    if (type === "assets") {
        optionGroups = [
            {
                options: [
                    {
                        id: FilterType.CATEGORY,
                        icon: "hashtag-square",
                        label: t("components.filters.category.label"),
                    },
                    {
                        id: FilterType.BRAND,
                        icon: "flag",
                        label: t("components.filters.brand.label"),
                    },
                    {
                        id: FilterType.SUPPLIER,
                        icon: "suitcase",
                        label: t("components.filters.supplier.label"),
                    },
                    {
                        id: FilterType.TAGS,
                        icon: "tag",
                        label: t("components.filters.tags.label"),
                    },
                ],
            },
            {
                options: [
                    {
                        id: FilterType.CREATED_DATE,
                        icon: "calendar-plus",
                        label: t("components.filters.created_date.label"),
                    },
                    {
                        id: FilterType.PURCHASED_DATE,
                        icon: "calendar-default",
                        label: t("components.filters.purchased_date.label"),
                    },
                ],
            },
        ];
    }

    if (type === "recurring_tasks") {
        optionGroups = [
            {
                options: [
                    {
                        id: FilterType.SPACES,
                        icon: "location-marker",
                        label: t("components.filters.spaces_or_assets.spaces"),
                    },
                    {
                        id: FilterType.ASSETS,
                        icon: "scan-object",
                        label: t("components.filters.spaces_or_assets.assets"),
                    },
                    {
                        id: FilterType.CATEGORY,
                        icon: "hashtag-square",
                        label: t("components.filters.category.label"),
                    },
                    {
                        id: FilterType.ASSIGNED_TO,
                        icon: "user-single",
                        label: t("components.filters.assigned_to.label"),
                    },
                    {
                        id: FilterType.PRIORITY,
                        icon: "error-circle",
                        label: t("components.filters.priority.label"),
                    },
                    {
                        id: FilterType.RECURRENCE,
                        icon: "repeat",
                        label: t("components.filters.recurrence.label"),
                    },
                ],
            },
        ];
    }

    if (tenantIds.length > 0) {
        if (type === "tasks" || type === "files") {
            optionGroups[0].options.unshift(
                {
                    id: FilterType.SPACES,
                    icon: "location-marker",
                    label: t("components.filters.spaces_or_assets.spaces"),
                },
                {
                    id: FilterType.ASSETS,
                    icon: "scan-object",
                    label: t("components.filters.spaces_or_assets.assets"),
                }
            );
        }

        if (type === "assets") {
            optionGroups[0].options.unshift(
                {
                    id: FilterType.SPACES,
                    icon: "location-marker",
                    label: t("components.filters.spaces_or_assets.spaces"),
                },
                {
                    id: FilterType.ASSET_GROUPS,
                    icon: "folder-open",
                    label: t(
                        "components.filters.spaces_or_assets.asset_groups"
                    ),
                }
            );
        }
    }

    return {
        optionGroups,
    };
}
